import React, { Component } from "react";
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';

import Value from '../components/Value';
import Status from '../components/Status';
import ListCollapse from '../components/ListCollapse';
import Date from '../components/Date';
import GetSingle from '../components/GetSingle';

import './ListItems.css';

class LeadListItems extends Component {
  static propTypes = {
    leads: PropTypes.array,
    loading: PropTypes.bool,
    reveal: PropTypes.string,
  }

  static contextTypes = {
    store: PropTypes.object,
  }

  static defaultProps = {
    loading: false,
    reveal: '',
  }

  constructor(props) {
    super(props);
    this.state = {
      reveal: props.reveal,
      key: 1,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.reveal !== this.props.reveal) {
      this.setState({ reveal: nextProps.reveal });
    }
  }

  setStateAsync(state) {
    return new Promise((resolve) => {
      this.setState(state, resolve);
    });
  }

  getReveal = () => {
    this.props.onReveal(this.state.reveal);
  }

  toggleShow = (i) => {
    this.setState({
      reveal: this.state.reveal === i ? null : i
    }, () => {
      this.getReveal();
    });
  }

  render() {
    return (
      <div className="ListItems">
        {
          [].concat(this.props.leads).map((obj, i) => (
              <Row key={i}>
              <Row className="row-eq-height">
                <Col className="indexCol">{i+1}</Col>
                <Col className="createdAt">
                  <GetSingle type="check" object={obj}>
                    <Date>{obj && obj.created_at}</Date>
                  </GetSingle>
                </Col>
                <Col xs={3}>
                <GetSingle type="profile" object={obj}>
                  {obj.name}
                </GetSingle> <br/>
                {obj.email} <br/>
                </Col>
                <Col xs={3} className="rowCol">
                <p>
                  {obj.bankNames && obj.bankNames.map((bnk, i) => (
                    <li key={i}>
                      {obj.bank && (<code>{obj.bank[i]}</code>)}&nbsp;
                      {bnk}
                    </li>
                  ))}
                </p>
                </Col>
                <Col xs={1} className="center">
                  {obj.leadType}
                </Col>
                <Col xs={1}>
                  <Status>
                    {obj.status}
                  </Status>  
                </Col>
                <Col className="actionCol">
                  <button className="buttonLink" onClick={() => this.toggleShow(obj.leadID)}>
                    {this.state.reveal === obj.leadID ? 'Hide Details' : `View More Details`}
                  </button>
                  <a className="buttonLink" href={`mailto:${obj.email}?Subject=[DSR-PG]`} target="_top">
                    Contact User
                  </a>
                </Col>
              </Row>
              <ListCollapse reveal={this.state.reveal === obj.leadID}>
                <Row className="titleRow">
                  <Col xs={6}>
                    <h5><b>Leads Details&nbsp;</b><code>{obj.leadID}</code></h5>
                  </Col>
                  <Col xs={6}>
                    <h5><b>Eligible Loan Amount</b></h5>
                  </Col>
                </Row>
                <Row>
                  <Col xs={3}>
                    <b>Mobile:</b> {obj.mobile.prefix && obj.mobile.suffix ? obj.mobile.prefix + obj.mobile.suffix : obj.mobile} <br />
                    <b>Project Name:</b> {obj.projectName ? obj.projectName : 'N/A'} <br />
                    <b>Reference:</b> {obj.reference} <br />
                  </Col>
                  <Col xs={3}>
                    <b>Refinance:</b> {this.dsrScore ? 'No' : 'Yes'} <br />
                    <b>OwnerShip Type:</b> <code>{obj.ownershipType}</code> <br />
                    <b>Lead Loan Amount:</b> <Value money>{obj.leadLoanAmount * 100}</Value> <br />
                  </Col>
                  <Col xs={3}>
                    <b>DSR Score:</b> <Value percent>{obj.dsrScore}</Value> <br />
                    <b>DSR Loan Amount:</b> <Value money>{obj.dsrLoanRange.loanAmount}</Value> <br />
                    <b>Income:</b> <Value money>{obj.incomeNetCent}</Value> <br />
                  </Col>
                  <Col xs={3}>
                    
                  </Col>
                </Row>  
              </ListCollapse>
            </Row>
            )
          )
        }
      </div>
    );
  }
}

export default connect(LeadListItems.mapStateToProps)(LeadListItems);



// WEBPACK FOOTER //
// ./src/components/LeadListItems.jsx